import { useTranslation } from "react-i18next"
import { PageHeader } from "../../components/HeaderComponents"
import { BreadCrumbsGeneral } from "../../components/NavigationComponents"
import { useContext, useEffect } from "react"
import { NotificationContext } from "../../contexts/NotificationContexts"
import { PermissionContext } from "../../contexts/PermissionContexts"
import { TicketCountGraph, TicketFirstReplyGraph, TicketStatsOverview } from "../../components/DashboardComponents"
import { useNavigate } from "react-router-dom"
import { AiExportButton } from "../../components/AiExportComponents"


export const StatisticsPage = () => {

    const { t } = useTranslation('dashboard')
    const { isSidebar, setIsSidebar } = useContext(NotificationContext)
    const { permissions, hasPermission } = useContext(PermissionContext)

    const navigator = useNavigate()



    useEffect(() => {
        if (permissions.length > 0 && !hasPermission("stats:page_view")) {
            navigator("/admin/dashboard")
        }
    }, [permissions])


    const breadCrumbs = [
        {
            link: "/admin/dashboard",
            name: t("Home")
        },
        {
            link: null,
            name: t("Statistics", { ns: 'sidebar' })
        }
    ]

    if (!hasPermission("stats:page_view")) {
        return <></>
    }

    return (
        <div className="flex flex-col justify-start items-center w-full py-2 gap-5 pb-10 px-4 h-full">
            <PageHeader pageTitle={t('Statistics', { ns: 'sidebar' })} />
            <div className="w-full flex flex-wrap items-start justify-between gap-3">
                <div>
                    <h1 className="text-xl font-semibold">{t('Statistics')}</h1>
                    <BreadCrumbsGeneral elements={breadCrumbs} />
                </div>
                {hasPermission("export:ai") && <AiExportButton />}
            </div>
            <div className="flex flex-col w-full gap-10 mt-7 mb-12">
                <div className="flex flex-col gap-2">
                    <span className="font-semibold text-lg">{t('Tickets Overview')}</span>
                    <TicketStatsOverview />
                </div>

                <div className="flex flex-col gap-2">
                    <span className="font-semibold text-lg">{t('Ticket Count')}</span>
                    <TicketCountGraph />
                </div>

                <div className="flex flex-col gap-2 mt-10">
                    <span className="font-semibold text-lg">{t('Ticket First Reply Delay')}</span>
                    <TicketFirstReplyGraph />
                </div>
            </div>
        </div>
    )
}